"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const net_1 = require("net");
const url_1 = require("url");
const dns_resolve_1 = __importDefault(require("./dns-resolve"));
async function parseHost(url, headers) {
    const parsedUrl = (0, url_1.parse)(url);
    const host = headers.get('host') || parsedUrl.host;
    if (!host) {
        throw new TypeError('Unable to determine Host');
    }
    headers.set('host', host);
    const ip = (0, net_1.isIP)(parsedUrl.hostname || '');
    if (ip === 0) {
        if (!parsedUrl.hostname) {
            throw new Error('Unable to determine hostname');
        }
        const newUrl = new URL(parsedUrl.href);
        newUrl.hostname = await (0, dns_resolve_1.default)(parsedUrl.hostname);
        url = newUrl.href;
    }
    return [url, host];
}
exports.default = parseHost;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiZmlsZTovLy9ob21lL2hicC9yZXBvcy9mZXRjaC9zcmMvcGFyc2UtaG9zdC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQUFBLDZCQUEyQjtBQUMzQiw2QkFBd0M7QUFFeEMsZ0VBQW9DO0FBRXJCLEtBQUssVUFBVSxTQUFTLENBQUMsR0FBVyxFQUFFLE9BQWdCO0lBQ3BFLE1BQU0sU0FBUyxHQUFHLElBQUEsV0FBUSxFQUFDLEdBQUcsQ0FBQyxDQUFDO0lBQ2hDLE1BQU0sSUFBSSxHQUFHLE9BQU8sQ0FBQyxHQUFHLENBQUMsTUFBTSxDQUFDLElBQUksU0FBUyxDQUFDLElBQUksQ0FBQztJQUVuRCxJQUFJLENBQUMsSUFBSSxFQUFFO1FBQ1YsTUFBTSxJQUFJLFNBQVMsQ0FBQywwQkFBMEIsQ0FBQyxDQUFDO0tBQ2hEO0lBRUQsT0FBTyxDQUFDLEdBQUcsQ0FBQyxNQUFNLEVBQUUsSUFBSSxDQUFDLENBQUM7SUFFMUIsTUFBTSxFQUFFLEdBQUcsSUFBQSxVQUFJLEVBQUMsU0FBUyxDQUFDLFFBQVEsSUFBSSxFQUFFLENBQUMsQ0FBQztJQUMxQyxJQUFJLEVBQUUsS0FBSyxDQUFDLEVBQUU7UUFDYixJQUFJLENBQUMsU0FBUyxDQUFDLFFBQVEsRUFBRTtZQUN4QixNQUFNLElBQUksS0FBSyxDQUFDLDhCQUE4QixDQUFDLENBQUM7U0FDaEQ7UUFPRCxNQUFNLE1BQU0sR0FBRyxJQUFJLEdBQUcsQ0FBQyxTQUFTLENBQUMsSUFBSSxDQUFDLENBQUM7UUFDdkMsTUFBTSxDQUFDLFFBQVEsR0FBRyxNQUFNLElBQUEscUJBQU8sRUFBQyxTQUFTLENBQUMsUUFBUSxDQUFDLENBQUM7UUFDcEQsR0FBRyxHQUFHLE1BQU0sQ0FBQyxJQUFJLENBQUM7S0FDbEI7SUFFRCxPQUFPLENBQUMsR0FBRyxFQUFFLElBQUksQ0FBQyxDQUFDO0FBQ3BCLENBQUM7QUEzQkQsNEJBMkJDIn0=